import React, { Suspense,useMemo } from "react";
import { useSelector } from "react-redux";
import ErrorBoundary from "../errorboundry";
import FallbackUI from "../fallbackUI";
import InvoiceItem from "./InvoiceItem"
function InvoiceItemList(props) {
 
  const InvoiceItems = useSelector((state) => state.InvoicesReducer.invoices);
  const {
    declarationTypeValue,
    isFormDisabled,
    translate,
    jobWheels
  } = props;
  const printInvoiceAndMerchandise = InvoiceItems.map((item, index) => (
    <div
      key={`invoice${index}`}
      style={{margin:"0 40px 0 20px"}}
    >
  
      <InvoiceItem
        key={item.invoiceId}
        invoiceItemIndex={index}
        totalInvoiceItems={InvoiceItems.length}
        isFormDisabled={isFormDisabled}
        declarationTypeValue={declarationTypeValue}
        translate={translate}
        jobWheels={jobWheels}
      />
    </div>
  ));

  const InvList = useMemo(
    () => printInvoiceAndMerchandise,
    [InvoiceItems.length,isFormDisabled,translate]
  );

  return (
    <ErrorBoundary>
        <React.Fragment>{InvList}</React.Fragment>
    </ErrorBoundary>
  );
}

export default React.memo(InvoiceItemList)
